import { useMutation } from '@tanstack/react-query'
import { CoreHttpClient, CoreResponse } from '@omnea-app/core/coreHttpClient'
import { ColumnsPromptType } from '@omnea-app/core/smart-table-filters/createSmartFilter'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'

export type FiltersInput = { input: string; columns: ColumnsPromptType; tableType: string }

type CreateSmartTableFilterResponse = CoreResponse<'/smart-table-filters', 'post'>

export const useCreateSmartFilterMutation = () => {
  const { getToken } = useAuthenticatedUser()
  return useMutation<CreateSmartTableFilterResponse['data'], CreateSmartTableFilterResponse['error'], FiltersInput>({
    mutationFn: async ({ input, columns, tableType }) => {
      const authorization = await getToken()
      const coreClient = new CoreHttpClient({ authorization })
      const { error, data } = await coreClient.POST('/smart-table-filters', {
        body: { input, columns, tableType },
      })
      throwIfApiError(error)

      return data
    },
  })
}
